import { createSelector } from 'reselect';
import type { RootState } from '@/app/store';

export const selectDashboard = (state: RootState): RootState['dashboard'] => state.dashboard;
export const selectDashboardStats = createSelector(selectDashboard, (d) => d.stats);
export const selectDashboardStatus = createSelector(selectDashboard, (d) => d.status);
export const selectDailyTargetProgress = createSelector(selectDashboardStats, (stats) => {
  if (!stats || stats.dailyConfirmationTarget === 0) return 0;
  return Math.round((stats.confirmedSoFar / stats.dailyConfirmationTarget) * 100);
});
